import React, { useState, useEffect } from "react";
import axios from "axios";
import { PolarArea } from 'react-chartjs-2';
import { Box,  CircularProgress } from '@mui/material';
import config from "../config.js"

const SalesChart2 = () => {
  const [salesData, setSalesData] = useState([]);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/SalesworkbookToJson`);
        setSalesData(response.data.data.Data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  const prepareChartData = () => {
    const polarData = salesData.map((item) => ({
      label: item.Salesman,
      data: [item.Sales, item.Revenue],
      backgroundColor: [
        'rgba(255, 99, 132, 0.5)',
        'rgba(54, 162, 235, 0.5)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
      ],
      borderWidth: 1,
    }));

    return polarData;
  };

  const polarData = prepareChartData();

  return (
    <div>
      <Box>
        {salesData.length === 0 ? (
          <CircularProgress />
        ) : (
          <Box>
            
            <PolarArea data={{ datasets: polarData }} />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default SalesChart2;

